<template>
  <div>
    Page Not Found
  </div>
</template>

<script>
  export default {
    name: "test123",
    mounted(){
      console.log('执行js')
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/personnelCenter/test123.vue